import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken} from '@/utils/auth'

NProgress.configure({showSpinner:false})
// const whiteList = ['/login','/auth-redirect','/bind','/register']

router.beforeEach((to,from,next)=>{
    NProgress.start()

    if(getToken()){
        if(to.path === '/login'){
            next({path:'/'})
            NProgress.done()
        }else{
            store.dispatch('GetInfo').then(res=>{
                //next({ ...to, replace: true })
                next();
            }).catch(err=>{
                store.dispatch('LogOut').then(()=>{
                    //Message.error(err || "出现错误，请稍后再试")
                    next({path:'/'})
                })
            })
        }
    }else{
        if (to.meta.requiresAuth) {
            next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
            NProgress.done()
        }else{
            next()
        }
    // if(whiteList.indexOf(to.path) != -1){
    //     next()
    // }else{
    //     // next(`/login?redirect=${to.path}`)
    //     NProgress.done()
    // }
    }
})

router.afterEach(() => {
    NProgress.done()
  })



// WEBPACK FOOTER //
// ./src/permission.js